import React from 'react';

import { Avatar, Card } from '@mui/material';

import Spin from 'components/Spin';
import Text from 'components/Text';
import { useUserProfileImage } from 'pages/IndividualBio/hooks/useUserProfileImage';

interface MappedMember {
  label: string;
  id: string;
}

interface InputComponentProps {
  selectedUser: MappedMember;
}

export const UserPicture: React.FC<InputComponentProps> = ({ selectedUser }) => {
  const { imageUrl: profileImage, loading: profileImgLoading } = useUserProfileImage(
    selectedUser?.id || ''
  );

  if (profileImgLoading) {
    return <Spin />;
  }

  return (
    <Card sx={{ width: '100%', alignItems: 'center', borderRadius: 2, justifyContent: 'center' }}>
      <Avatar
        src={profileImage || undefined}
        alt="User"
        sx={{ width: 120, height: 120, justifySelf: 'center' }}
      />
      <Text size="xLarge" bold textAlign="center">
        {selectedUser?.label}
      </Text>
    </Card>
  );
};
